export const locale = {
  GENERAL: {
    LOADING: "Loading",
    ONLINE: "online",
    ADD: "Add",
    EDIT: "Edit",
    DELETE: "Delete",
    SUBMIT: "Submit",
    SAVE: "Save",
    CANCEL: "Cancel",
    DISCARD: "Discard",
    SEARCH: "Search",
    PLEASE_SELECT: "Please select...",
    SELECTED: "Selected",
    EXPORT: "Export",
    ACTIONS: "Actions",
    VIEW: "View",
    PLEASE_WAIT: "Please wait...",
    ALL: "All",
    BAHT_SYMBOL: "฿",
    BAHT: "Baht",
    MONTH: {
      JAN: "Jan",
      FEB: "Feb",
      MAR: "Mar",
      APR: "Apr",
      MAY: "May",
      JUN: "Jun",
      JUL: "Jul",
      AUG: "Aug",
      SEP: "Sep",
      OCT: "Oct",
      NOV: "Nov",
      DEC: "Dec",
    },
    CONFIRM: "Confirm",
    ADDRESS_PLACEHOLDER:
      "Determine the address in detail, consisting of house numbers, alleys, villages, roads",
    BACK: "Back",
    SAVE_AND_CONTINUE: "Save and continue",
    CLEAR_FORM: "Clear form",
    DOWNLOAD: "Download",
    COPY_LINK: "Copy link",
    COPY_LINK_SUCCESS: "Copy link success!",
  },
  POPUP_MESSAGE: {
    LOGIN_SUCCESS: "You have successfully logged in!",
    SAVE_SUCCESS: "You have successfully!",
    SUCCESS_MESSAGE_CONFIRM: "Ok, got it!",
    ERROR_MESSAGE_CONFIRM: "Try again!",
  },
  SWAL: {
    CONFIRM: {
      SAVE: {
        TITLE: "Confirm Save",
        MESSAGE: "Do you want to save ?",
        SUBMIT: "Confirm",
      },
      DELETE: {
        TITLE: "Confirm Delete",
        MESSAGE: "Do you want to delete ?",
        SUBMIT: "Confirm",
      },
    },
  },
  PAGINATION: {
    SHOW_FROM_TO_OF: "Showing {from} to {to} of {total} entries",
  },
  DATE_PERIOD: {
    TODAY: "Today",
    LAST_SEVEN_DAYS: "Last 7 days",
    LAST_MONTH: "Last month",
    LAST_THREE_MONTHS: "Last three months",
    LAST_SIX_MONTHS: "Last six months",
    LAST_YEAR: "Last year",
    THIS_WEEK: "This week",
    THIS_MONTH: "This month",
    THIS_YEAR: "This year",
  },
  COMPANY: {
    NAME: "Nation University",
  },
  TRANSLATOR: {
    LANGUAGE: "Language",
    ENGLISH: "English",
    THAILAND: "Thailand",
  },
  FOOTER: {
    ABOUT: "About",
    TERM: "Term",
    CONTACT: "Contact",
    CONTACT_US: "Contact Us",
  },
  MENU: {
    DASHBOARD: {
      TITLE: "Dashboard",
    },
    SETTINGS: {
      TITLE: "Settings",
      PEOPLE: {
        TITLE: "People",
        PEOPLE_LIST: "People List",
        PEOPLE_DETAIL: "People Detail",
      },
      PROJECT: {
        TITLE: "Project",
        LIST: "Project List",
        DETAIL: "Project Detail",
      },
      DIVISION: {
        TITLE: "Division",
        LIST: "Division List",
        DETAIL: "Division Detail",
      },
      PREFIX: {
        TITLE: "Prefix",
        LIST: "Prefix List",
        DETAIL: "Prefix Detail",
      },
      TEACHER_APPLY: {
        TITLE: "Teacher Apply",
        LIST: "Teacher Apply List",
        DETAIL: "Teacher Apply Detail",
      },
      SYSTEM_CONFIG: {
        TITLE: "System Config",
      },
    },
  },
  VIEW: {
    DASHBOARD: {
      TITLE: "Dashboard",
    },
  },
  COMPONENT: {
    DASHBOARD: {
      ORDER_THIS_MONTH: {
        TITLE: "Orders This Month",
        TO_GOAL: "to Goal",
        NO_ANY_ORDER: "No Any Order",
      },
      AVERAGE_DAILY_SALES: {
        TITLE: "Average Daily Sales",
      },
      NEW_CUSTOMER_THIS_MONTH: {
        TITLE: "New Customers This Month",
        NO_TODAY_HERO: "No Today’s Heroes",
        TODAY_HERO: "Today’s Heroes",
        NO_ANY_NEW_CUSTOMER: "No Any New Customer",
      },
      TOP_TREE_BEST_SELLER: {
        TITLE: "Top 3 Best Seller This Month",
        NO_ANY_PRODUCT: "No Any Product",
      },
      SALES_THIS_MONTHS: {
        TITLE: "Sales This Months",
        SUB_TITLE: "Sales from all channels",
      },
    },
  },
  USER: {
    TITLE: "User",
    EMAIL: "Email",
    NAME: "Name",
    SURNAME: "Surname",
    ROLE: "Role",
    ACCOUNT_SETTING: "Account Settings",
    MY_PROFILE: "My Profile",
    MY_STATEMENTS: "My Statements",
    SIGN_OUT: "Sign Out",
  },
  DASHBOARD: {
    TITLE: "Dashboard",
    FILTER: "Filter",
    ENROLL_DATE: "Enroll Date",
    STUDY_LEVEL: "Study Level",
    ENROLL_START_DATE: "Enroll Start Date",
    ENROLL_END_DATE: "Enroll End Date",
    CURRICULUM: "Curriculum",
  },
  AUTH: {
    GENERAL: {
      PRIVACY: "Privacy",
      ABOUT: "About",
      CONTACT: "Contact",
      CONTACT_US: "Contact Us",
      TERM: "Terms",
      EMAIL: "Email",
      PASSWORD: "Password",
      NAME: "Name",
      SURNAME: "Surname",
      AGREE: "I Agree the",
      TERM_AND_CONDITIONS: "terms and conditions",
      CONTINUE: "Continue",
      PLEASE_WAIT: "Please wait...",
    },
    LOGIN: {
      TITLE: "Welcome to Landing Page Nation",
      NEW_HERE: "New Here?",
      CREATE_ACCOUNT: "Create an Account",
      FORGOT_PASSWORD: "Forgot Password ?",
      CONTINUE_WITH_FACEBOOK: "Continue with Facebook",
      FB_LOGIN_FAILED: "Login with Facebook not success.",
      FB_LOGIN_FAILED_DESC: "User cancelled login or dit not fully authorize.",
    },
    FORGOT: {
      TITLE: "Forgot Password?",
      DESC: "Enter your email to reset your password",
      SUBMIT: "Submit",
      CANCEL: "Cancel",
    },
    REGISTER: {
      TITLE: "Sign Up",
      DESC: "Enter your details to create your account",
      SUBMIT: "Submit",
      CANCEL: "Cancel",
    },
    INPUT: {
      EMAIL: "Email",
      FULL_NAME: "Full name",
      PASSWORD: "Password",
      CONFIRM_PASSWORD: "Confirm Password",
      USERNAME: "Username",
    },
  },
  SETTING: {
    PEOPLE: {
      TITLE: "Person Details",
      PICTURE: "Picture",
      PREFIX: "Prefix",
      NAME: "Name",
      SURNAME: "Surname",
      EMAIL: "Email",
      ROLE: "Role",
      PASSWORD: "Password",
      PASSWORD_CONFIRM: "Password Confirmation",
      PASSWORD_MUST_MATCH: "Passwords must match",
      PEOPLE: "People",
      LAST_LOGIN_DATE: "Last Login",
      JOINED_DATE: "Joined Date",
      SIGN_IN_METHOD: "Sign-in Method",
      ENTER_NEW_EMAIL: "Enter New Email",
      DEACTIVATE_ACCOUNT_TITLE: "Deactivate Account",
      DEACTIVATE_ACCOUNT: "Deactivate Account",
      CONFIRM_DEACTIVATE_ACCOUNT: "I confirm to account deactivation",
      DEACTIVATED_SUCCESS: "Account deactivation success.",
      CHANGE_EMAIL: "Change Email",
      UPDATE_EMAIL: "Update Email",
      RESET_PASSWORD: "Reset Password",
      UPDATE_PASSWORD: "Update Password",
      NEW_PASSWORD: "New Password",
      CONFIRM_NEW_PASSWORD: "Confirm New Password",
    },
    ROLE: {
      ENROLLER: "Enroller",
      ENROLLER_DESCRIPTION: "Best for enroller",
      ADMIN: "Admin",
      ADMIN_DESCRIPTION: "Best for employee who had administrator",
    },
    PROJECT: {
      TITLE: "Project",
      NAME: "Name",
    },
    DIVISION: {
      TITLE: "Division",
      NAME: "Name",
      other: "Other",
    },
    PREFIX: {
      TITLE: "Prefix",
      NAME: "Name",
      other: "Other",
    },
    TEACHER_APPLY: {
      TITLE: "Teacher Apply",
      NAME: "Name",
      other: "Other",
    },
    SYSTEM_CONFIG: {
      TITLE: "System Config",
      COMPANY_CONFIG: "Company Config",
      APP_LOGO: "Logo",
      COMPANY_NAME: "Company Name",
      COMPANY_ID_NUMBER: "Company Id Number",
      COMPANY_ADDRESS_1: "Company Address 1",
      COMPANY_ADDRESS_2: "Company Address 2",
      COMPANY_EMAIL: "Company Email",
      COMPANY_PHONE_NUMBER: "Company Phone Number",
      SALE_CONFIG: "Sale Config",
    },
  },
  UPLOAD: {
    DROP_FILE_HERE: "Drop files here or click to upload.",
    VIDEO_LIMIT: "File video size less than 1gb",
    DOCUMENT_LIMIT: "File .pdf less than 2mb",
  },
  ENROLL: {
    TITLE: "ลงทะเบียนรับคำปรึกษา",
    BACHELOR_DESCRIPTION: "ระดับปริญญาโท หลักสูตรบริหารธุรกิจ (MBA.)",
    MBA_DESCRIPTION: "ระดับปริญญาโท หลักสูตรบริหารธุรกิจ (MBA.)",
    MED_DESCRIPTION: "ระดับปริญญาโท หลักสูตรการบริหารการศึกษา (ME.d)",
    PREFIX: "คำนำหน้า",
    NAME: "ชื่อ",
    SURNAME: "นามสกุล",
    MOBILE: "เบอร์โทรศัพท์",
    SEND_DATA: "ส่งข้อมูล",
    ID_NUMBER: "เลขที่บัตรประชาชน 13 หลัก",
    LINE_ID: "Line Id",
    WEIGHT: "น้ำหนัก (กิโลกรัม)",
    HEIGHT: "ส่วนสูง (เซนติเมตร)",
    EDUCATION: "วุฒิการศึกษา",
    INSTOTUTE: "ชื่อสถานศึกษา",
    STUDY_PLAN: "แผนการเรียน",
    GPA: "เกรดเฉลี่ย (GPA หรือ GPAX)",
    PROJECT: "ประเภทโครงการที่ต้องการสมัคร",
    DIVISION: "คณะที่ต้องการสมัคร",
    TEACHER_APPLY: "อาจารย์ผู้รับสมัคร",
    UPLOAD:
      "อัพโหลดเอกสารการสมัคร (สำเนาบัตรประชาชน, สำเนาทะเบียนบ้าน, ผลการเรียน, รูปถ่ายขนาด 1 นิ้ว และหลักฐานการชำระเงินค่าสมัครเรียน) รวมเอกสารเป็น PDF ไฟล์เดียวกัน",
    CREATED_AT: "สมัครเมื่อ",
    CONTACT_TIME: "เวลาติดต่อ",
    PROVINCE: "จังหวัด",
    CONFIRM: "ยืนยันเพื่อให้ข้อมูลเพื่อให้ทางมหาวิทยาลัยติดต่อกลับ",
  },
};
